export default __webpack_public_path__ + "static/media/cy.7715712c.jpg";